import { Languages } from 'helpers/enum'

export const AVAILABLE_LANGUAGES = Object.keys(Languages).map((lang) =>
    lang.toLowerCase()
)

export const DEFAULT_LANG = Languages.PL
